import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PublicBooking from './pages/public/PublicBooking';
import BusinessLayout from './pages/business/Layout';
import Dashboard from './pages/business/Dashboard';
import Clients from './pages/business/Clients';
import Expenses from './pages/business/Expenses';
import PendingExpenses from './pages/business/PendingExpenses';
import PersonalExpenses from './pages/business/PersonalExpenses';
import Purchases from './pages/business/Purchases';
import Catalog from './pages/business/Catalog';
import CatalogView from './pages/public/CatalogView';
import Appointments from './pages/business/Appointments';
import AppointmentConfig from './pages/business/AppointmentConfig';
import Debts from './pages/business/Debts';
import Products from './pages/business/Products';
import Stock from './pages/business/Stock';
import Profile from './pages/business/Profile';
import Revenue from './pages/business/Revenue';
import RevenueDetail from './pages/business/RevenueDetail';
import SalesList from './pages/business/SalesList';
import UsersPanel from './pages/business/UsersPanel';
import AdminLayout from './pages/admin/Layout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminUsers from './pages/admin/Users';
import AdminRevenue from './pages/admin/Revenue';
import AdminPages from './pages/admin/Pages';

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="spinner" style={{ marginTop: '40vh' }} />;
  if (!user) return <Navigate to="/" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  useEffect(() => {
    // Use classList.toggle to avoid wiping classes added by child components (e.g. public-page from CatalogView)
    document.body.classList.toggle('theme-estetica', user?.theme === 'estetica');
  }, [user]);

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/business'} replace /> : <Login />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/reservar/:slug" element={<PublicBooking />} />
      <Route path="/catalogo/:slug" element={<CatalogView />} />
      <Route path="/business" element={<ProtectedRoute role="business"><BusinessLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="pending-expenses" element={<PendingExpenses />} />
        <Route path="personal-expenses" element={<PersonalExpenses />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="appointments-config" element={<AppointmentConfig />} />
        <Route path="debts" element={<Debts />} />
        <Route path="products" element={<Products />} />
        <Route path="stock" element={<Stock />} />
        <Route path="profile" element={<Profile />} />
        <Route path="revenue" element={<Revenue />} />
        <Route path="revenue-detail" element={<RevenueDetail />} />
        <Route path="sales-list" element={<SalesList />} />
        <Route path="users" element={<UsersPanel />} />
      </Route>
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="revenue" element={<AdminRevenue />} />
        <Route path="pages" element={<AdminPages />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
